import React from "react";
//#region types
import { NavigationListMenuItemProps } from "models/propTypes/navListPropTypes";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Icon, MenuButton, RoundButton } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import { useNavigate, useLocation } from "react-router-dom";

const NavigationSubItemMenu: React.FC<NavigationListMenuItemProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const onMenuItemClick = async (path: string) => {
    navigate(props.path.concat(path), {
      state: { background: location },
    });
  };

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];

    actions.push(props.displayText);

    props.children?.forEach((item) => {
      actions.push({
        menuKey: item.id,
        description: LocalizationHelperInstance.getFormattedMessage(item.displayText),
        icon: item.icon,
        highlightType: StyleEnums.DisplayType.None,
        onClickHandler: onMenuItemClick.bind(null, item.path),
        hidden: item.hidden,
      });
    });

    return actions;
  };

  return (
    <MenuButton
      menuItems={getMenuItems()}
      button={
        <RoundButton size="xs">
          <Icon icon={props.icon} className={cssExports.navListIcon} />
        </RoundButton>
      }
      menuPlacement={"right"}
      classes={{
        menuOpen: cssExports.navListMenuItemOpen,
      }}
      disablePopperPortal={false}
      popperOffSet={[0, 30]}
      allowClickEventPropagation
    />
  );
};

export default NavigationSubItemMenu;
